export const itemTypes = {
    BOXES: "boxes",
    SPAWNS: "spawns",
    COLLECTABLES: "collectables",
    ANIMALS: "animals",
    SUPPLIES: "supplies",
};
